import React from 'react';
import branch_icon from '../assets/branch_icon.svg';
import { locale } from '../utils/getLocale';

export default function BranchDetailsCard ({ branch}){
  if(!branch){
    return null;
  }
    return (
      <div className="branch-details-card hidden lg:block">
        <div  className="branch-details-card__container">
          <div className="branch-details-card__aspect">
            <img
              src={branch.image}
              alt={branch.title}
              className="branch-details-card__image"
            />

            {/* Bottom Info Card */}
            <div className="branch-details-card__bottom">
              <div className="branch-info">
                {/* Header with icon and availability */}
                <div className="branch-info__header">
                  <div className="branch-info__title-wrapper">
                    <div className="branch-info__icon">
                      <img src={branch_icon}   className="branch-info__icon-svg" />
                    </div>
                    <h2 className="branch-info__title">{branch.title}</h2>
                  </div>
                  <div className="branch-info__availability">
                   {getInfoText(branch)}
                  </div>
                </div>

                {/* Addresses */}
                <div className="branch-info__addresses">

                {branch.addresses && branch.addresses.length > 0 && (
                   <ul>
                   {branch.addresses.map((address, index) => (
                     <li key={index}>{address}</li>
                   ))}
                 </ul>
                 )}
                 </div>
                {/* CTA Button */}
                <a
                  className="cta-button"
                  href="#contact"
                >
                    <span>{locale('Found your branch? Lets talk!')}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  export const getInfoText = (branch) => {
    if(!branch.addresses || branch.addresses.length === 0){
      return locale('Open opportunity');
    }
    if(branch.addresses.length  === 1) {
      return locale('Only one branch left');
    }
    return `${branch.addresses.length} ${locale('branches left')}`;
  };

